"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomPropTypes = exports.RoomFacilityPropTypes = exports.MealTypePropTypes = exports.LtExtras = exports.HotelOfferPropTypes = exports.HotelOfferExtrasPropTypes = exports.HotelFacilityPropTypes = exports.AvailabilityPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _types = _interopRequireDefault(require("../../components/TourQuantity/types"));
var HotelOfferExtrasPropTypes = exports.HotelOfferExtrasPropTypes = _propTypes["default"].shape({
  previous_price: _propTypes["default"].number,
  instant_confirm: _propTypes["default"].bool,
  early_booking: _propTypes["default"].bool,
  cheap: _propTypes["default"].bool
});
var LtExtras = exports.LtExtras = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  show_on: _propTypes["default"].string.isRequired,
  tooltip: _propTypes["default"].string.isRequired,
  active: _propTypes["default"].bool.isRequired,
  icon_path: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  partner_id: _propTypes["default"].number.isRequired,
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]).isRequired,
  description: _propTypes["default"].string.isRequired,
  voucher_text: _propTypes["default"].string.isRequired
}));
var checkAvailabilityProps = function checkAvailabilityProps(props) {
  if (!props.hotel || !props.flight || !_types["default"].includes(props.hotel) || !_types["default"].includes(props.flight)) {
    return new Error('At least one of props: "hotel" or "flight" must be provided!');
  }
};
var AvailabilityPropTypes = exports.AvailabilityPropTypes = _propTypes["default"].shape({
  tooltip: _propTypes["default"].string,
  hotel: checkAvailabilityProps,
  flight: checkAvailabilityProps
});
var HotelOfferPropTypes = exports.HotelOfferPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  price: _propTypes["default"].number.isRequired,
  nights_count: _propTypes["default"].number.isRequired,
  operator_id: _propTypes["default"].number.isRequired,
  operator_name: _propTypes["default"].string.isRequired,
  start_date: _propTypes["default"].string.isRequired,
  availability: AvailabilityPropTypes.isRequired,
  lt_extras: LtExtras,
  extras: HotelOfferExtrasPropTypes
});
var RoomFacilityPropTypes = exports.RoomFacilityPropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string.isRequired,
  group_identifier: _propTypes["default"].string.isRequired
});
var HotelFacilityPropTypes = exports.HotelFacilityPropTypes = _propTypes["default"].shape({
  name: _propTypes["default"].string.isRequired,
  text: _propTypes["default"].string.isRequired,
  best: _propTypes["default"].bool
});
var RoomPropTypes = exports.RoomPropTypes = _propTypes["default"].shape({
  name_ru: _propTypes["default"].string.isRequired,
  name_en: _propTypes["default"].string,
  accommodation: _propTypes["default"].string,
  area: _propTypes["default"].number,
  description: _propTypes["default"].string,
  facilities: _propTypes["default"].arrayOf(RoomFacilityPropTypes).isRequired,
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x900: _propTypes["default"].string.isRequired,
    x900x380: _propTypes["default"].string,
    full: _propTypes["default"].string
  }))
});
var MealTypePropTypes = exports.MealTypePropTypes = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  min_price: _propTypes["default"].number.isRequired,
  description: _propTypes["default"].string.isRequired
});